export default __webpack_public_path__ + "static/media/84.01702137.svg";